const API_URL = process.env.REACT_APP_API_URL;
console.log(`API to: ${API_URL}`);

export default API_URL;
